<template>
  <div class="FlashbaseCommentContent">
    <div class="title">
      <left-square-outlined @click="onGoBack" />
      <h4>{{ $t('orderManagement.Comment.orderComment') }}</h4>
    </div>
    <div v-for="item in order_item"
         :key="item.id">
      <FlashbaseCommentItem v-if="!item.is_comment"
                            :item="item"
                            :is-edit="false"
                            :is-divider="true"
                            :is-append="false"
                            @create-success="createSuccess"></FlashbaseCommentItem>
      <FlashbaseCommentContent v-else
                               :item="item"
                               :is-order="true"
                               :is-custom="false"
                               :data="item.comments"
                               @append-show="append(item)">
        <template #appendComment>
          <FlashbaseCommentAppend v-if="item.comments.length > 0"
                                  :append-list="commentDate(item.comments)"
                                  :created-at="item.comments[0].createdAt"></FlashbaseCommentAppend>
        </template>
      </FlashbaseCommentContent>
      <a-modal v-model:visible="is_append"
               :title="$t('orderManagement.Comment.append')"
               width="50%"
               :footer="null">
        <div class="FlashbaseCommentItem">
          <FlashbaseCommentItem :item="append_data"
                                :is-edit="false"
                                :is-divider="false"
                                :is-append="true"
                                @create-success="createSuccess"></FlashbaseCommentItem>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue"
import { useRoute, useRouter } from "vue-router"
import { fetchOrderComment } from "../../api/index"
import { sortBy } from "../../../custom-spus/utils"
const route = useRoute()
const router = useRouter()
// const order_detail = ref()
const order_item = ref()
onMounted(async () => {
  await init()
})
const init = async () => {
  const id = route.params.id as any
  const query = route.query.order_item_id
  await fetchOrderComment(id, query ? { id: query } : {}).then((res: any) => {
    // order_detail.value = res
    order_item.value = res
    for (let i = 0; i < res.length; i++) {
      res[i].comments = listToTree(res[i].comments)
    }
  })
  is_append.value = false
}
const onGoBack = () => {
  const id = route.params.id
  const query = route.query.order_item_id
  query ? router.push(`/console/orders/order_management/${id}`) : router.push(`/console/orders/order_management`)
}
const listToTree = (arr: any[]) => {
  const treeData = [] as any
  // 深拷贝
  const arrClone = JSON.parse(JSON.stringify(arr))
  // 映射表 => 快速找到上级
  const mapInfo = arrClone.reduce((obj: any, item: any) => {
    item.children = []
    obj[item.id] = item
    return obj
  }, {})
  // console.log('转树函数map', mapInfo)
  // 转树
  arrClone.forEach((item: any) => {
    const parent = mapInfo[item.parent_id]
    // 如果父节点存在, 直接push到父级的children数组里面
    // 如果父级不存在, 说明本身就是一级, 直接push到treeData数组
    parent ? parent.children.push(item) : treeData.push(item)
  })
  return treeData

}
const createSuccess = async () => {
  await init()
}
const is_append = ref<boolean>(false)
const append_data = ref<any>()
const append = (value: any) => {
  is_append.value = true
  append_data.value = value
}
const commentDate = (data: any) => {
  // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
  return data[0].children ? data[0].children.sort(sortBy('createdAt', true)) : []
}
</script>
<style scoped lang="less">
.FlashbaseCommentContent {
  padding: 20px;
  height: 100%;
  overflow: scroll;
  padding-top: 0;

  .title {
    position: sticky;
    top: 0;
    display: flex;
    height: 55px;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 0;
    margin-bottom: 10px;
    background: #fff;
    z-index: 1000;

    h4 {
      margin: 0 0 0 10px;
    }
  }

  .FlashbaseCommentItem {
    margin-top: 20px;
    padding: 20px;
    background: #F6F6F6;
  }
}
</style>